module.exports = __webpack_public_path__ + "assets/920a2067aee01ef76a88173ac8a7270f.png";